import { AppState } from '../../types/store';
import { getModuleData } from './modules';

export const getAboutMeData = (state: AppState, moduleId: number) =>
  getModuleData(state, moduleId) || {};

export const getBadges = (state: AppState, moduleId: number) =>
  getAboutMeData(state, moduleId).badges;
